import request from '../libs/request';

const res = 'Shortcut';

export default {
  queryMy() {
    return request({
      url: `api/${res}/queryMy`,
      method: 'post',
      data: {}
    });
  },
  save(data) {
    return request({
      url: `api/${res}/save`,
      method: 'post',
      data
    });
  }
};
